import React, { useEffect } from 'react';
import { Button } from '../button/Button';
import i18n from '../../common/i18n';
import BetRegisteredIcon from '../../icons/BetRegisteredIcon';
import { clearError, showLuckyWheelError } from './h&s';
import { dispatch, useReframe } from 'nike-re-framejs';

const LuckyWheelConfirmReject = ({ handleReject, handleBack, closeDialogWhenError }) => {
    const { subscribe } = useReframe();
    const error = subscribe(showLuckyWheelError);

    useEffect(() => () => dispatch(clearError), []);

    return (
        <div className="lucky-wheel-confirm-reject">
            <div className="reject-icon">
                <BetRegisteredIcon fill="#7f7f7f" width={150} height={150} />
            </div>
            <div className="mt-20 mb-20">
                <h1 className="fs-20 text-extra-bold uppercase text-center" style={{ lineHeight: 1.2 }}>
                    {i18n('luckyWheel.confirmReject.title')}
                </h1>
                <div className="text-center c-black-50-2 fs-14 mt-20 mb-20">
                    {error || i18n('luckyWheel.confirmReject.subTitle')}
                </div>
            </div>
            <div className="buttons">
                {error ? (
                    <Button
                        large
                        onClick={() => {
                            closeDialogWhenError();
                            dispatch(clearError);
                        }}
                        label={i18n('nui.button.close')}
                        dataAtid="lucky-wheel-confirm-dialog-reject"
                        className="nui-button-130 red mr-10"
                    />
                ) : (
                    <>
                        <Button
                            large
                            secondary
                            onClick={handleBack}
                            label={i18n('nui.button.back')}
                            dataAtid="lucky-wheel-reject-dialog-back"
                            className="nui-button-130  mr-10 grey"
                        />
                        <Button
                            primary
                            large
                            onClick={handleReject}
                            label={i18n('nui.bonus.zamietnutBonus')}
                            dataAtid="lucky-wheel-reject-dialog-reject"
                            className="nui-button-130 ml-10"
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default LuckyWheelConfirmReject;
